import { DashboardIssue, DashboardIssueType } from "../schema/dashboard";

/**
 * Advisory items, shown as "Suggestions" rather than "Issues" (PREC-3594).
 *
 * The difference is what the user is being asked for. An issue is something broken — a
 * disconnected account, a failing sync — that keeps the product from working until it is fixed. A
 * suggestion is a judgement call the product cannot make on its own: the competitor list is
 * *working*, and the user is being invited to check it. Putting the two in one red "Issues found"
 * box read as a fault report for something that is behaving exactly as designed.
 */
export const SUGGESTION_ISSUE_TYPES = new Set<DashboardIssueType>([
	DashboardIssueType.COMPETITORS_NEED_REVIEW,
]);

export const isSuggestion = (issue: DashboardIssue): boolean =>
	SUGGESTION_ISSUE_TYPES.has(issue.type);

/** Splits what the dashboard endpoint returns into the two boxes that render it. */
export const partitionDashboardIssues = (
	issues: DashboardIssue[]
): { issues: DashboardIssue[]; suggestions: DashboardIssue[] } => ({
	issues: issues.filter((issue) => !isSuggestion(issue)),
	suggestions: issues.filter(isSuggestion),
});
